export default "__VITE_ASSET__BQQA5piA__"